import { DeliveryTypes, StorageKeys } from "@utils/enums";

import createValueModule from "@redux/create-value-module";

import {
    $ProductDetailModuleName,
    TProductDetailState,
} from "./productDetail.types";

export const getDeliveryType = (): DeliveryTypes => {
    if (
        typeof sessionStorage !== "undefined" &&
        typeof window !== "undefined"
    ) {
        return (
            (sessionStorage.getItem(
                StorageKeys.DeliveryType,
            ) as DeliveryTypes) || DeliveryTypes.ClickAndCollect
        );
    }

    return DeliveryTypes.ClickAndCollect;
};

const { constants: _constants, actions } =
    createValueModule<TProductDetailState>($ProductDetailModuleName, {
        deliveryType: DeliveryTypes.ClickAndCollect,
        shop: null,
        quantity: 1,
        sku: "",
        stickyOrderButton: false,
        serviceProductSkus: [],
    });

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
